import React, { useState } from 'react';
import PropTypes from 'prop-types';

import Container from '@mui/material/Container';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import Checkbox from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';

import AppNotification from 'shared/AppNotification';

import axios from 'utils/axios-rails';

const propTypes = {
  submitURL: PropTypes.string.isRequired,
  isAdmin: PropTypes.bool,
}

const defaultProps = {
  isAdmin: false
}

const InvoiceAdminIssue = (props) => {
  const [bpId, setBpId] = useState("");
  const [forceIssue, setForceIssue] = useState(false); // Only relevant to admins
  const [error, setError] = useState(null); // Only relevant to admins

  const [toast, setToast] = useState(null);
  const [loading, setLoading] = useState(false);

  const closeToast = () => setToast(null);

  const handleSubmit = async (event, basura) => {
    event.preventDefault();
    setLoading(true);
    setError(null);
    try {
      const response = await axios.post(props.submitURL, {
        bp_id: bpId,
        force_issue: forceIssue
      });
      setBpId("");
      setForceIssue(false);
      setToast(response.data.message);
      console.log("R", response)
    } catch (error) {
      const ex = error;
      console.log("MAX", error);
      if(error.response && error.response.data){
        console.log(error.response.data);
        setToast(error.response.data.message);
        setError(error.response.data.error);
      } // errors
    }
    setLoading(false);
  }

  const handleCheckboxChange = (event, value) => {
    setForceIssue(event.target.checked);
  }

  const handleIdChange = (event) => {
    setBpId(event.target.value);
  }

  return (
    <Container className="mt20">
      <AppNotification
        open={ !!toast }
        message={ toast }
        severity={ error ? 'error' : 'success' }
        handleClose={ closeToast }
        position={{ vertical: 'top', horizontal: 'right' }}
      />

      <Card>
        <CardContent>
          <Typography variant="h6" gutterBottom>Generar factura electrónica manualmente</Typography>
          <form onSubmit={ handleSubmit }>
            <TextField
              label="ID de órden de Brightpearl"
              value={ bpId }
              onChange={ handleIdChange }
              placeholder="000"
              error={ !!error }
              helperText={ error || undefined }
              fullWidth
              size="small"
              margin="normal"
            />

            {/* checkbox */}
            { props.isAdmin &&
              <FormControlLabel
                control={
                  <Checkbox
                    id="force_issue"
                    checked={ forceIssue }
                    onChange={ handleCheckboxChange }
                  />
                }
                label="Reenviar"
              />
            }

            <div>
              <Button
                color="brandYellow"
                variant="contained"
                disableElevation
                type="submit"
                className="border-0 pv8 ph16 font-weight-bold mt20"
                disabled={ loading }
              >
                { loading ? "ENVIANDO..." : "ENVIAR" }
              </Button>
            </div>
          </form>
        </CardContent>
      </Card>
    </Container>
  )
};

InvoiceAdminIssue.propTypes = propTypes;
InvoiceAdminIssue.defaultProps = defaultProps;

export default InvoiceAdminIssue;
